import { Theme, useMediaQuery } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import ConfirmationDialog from "../../../components/Misc/Dialog/ConfirmationDialog";
import { useSnackbar } from "notistack";
import { APIsContext } from "../../../Store/APIs/context";
import ExceptionsFilterTable from "../components/ExceptionsFilterTable";
import DownloadSettingsTable from "../components/DownloadSettingsTable";
import ManagementSettingTable from "../components/ManagementSettingTable";
import DatabaseTable from "../components/DbClusterTable";
import { DbClusterStatus } from "neurotec-megamatcherid-management-client";

interface IManagement {
    hasClear?: boolean,
    getExceptionFilter: (type: "name" | "http" | "path") => string,
    setExceptionFilter: (type: "name" | "http" | "path", value: string) => void
}

const Management: React.FC<IManagement> = (props) => {

    const { enqueueSnackbar } = useSnackbar();
    const state = useContext(APIsContext).state
    const [managementState, setManagementState] = useState<{[key: string]: object}>();
    const [dbClusterStatus, setDbClusterStatus] = useState<DbClusterStatus>();
    const [dialogOpen, setDialogOpen] = useState(false)
    const [activeButton, setActiveButton] = useState(true)
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

    useEffect(() => {
        const fetchData = async () => {
            state.ManagementApi.getManagementInfo().then(res => {
                setManagementState(res.data)
            }).catch(e => {
                enqueueSnackbar(e.message, {variant: "error"})
            })
        }
        fetchData()
    }, [state.ManagementApi, enqueueSnackbar])

    useEffect(() => {
        const fetchData = async () => {
            state.ManagementApi.getClusterStatus().then(res => {
                setDbClusterStatus(res.data)
            }).catch(e => {
                enqueueSnackbar(e.message, {variant: "error"})
            })
        }
        fetchData()
    }, [state.ManagementApi, enqueueSnackbar])

    const clearDb = () => {
        if ((managementState?.prefixMode as unknown as string) === "false") {
            enqueueSnackbar("Clear DB can only be done from management page", {variant: "warning"})
            return;
        }
        setActiveButton(false)
        state.ManagementApi.truncateDatabase().then(res => {
            enqueueSnackbar("DB cleared successfully", {variant: "info"})
        }).catch(err => {
            console.error(err);
            enqueueSnackbar("Unable to clear DB", {variant: "error"})
        }).finally(() => {
            setActiveButton(true)
        })
    }

    return (
        <>
            <ManagementSettingTable
                hasClear={props.hasClear}
                isMobile={isMobile}
                setDialogOpen={(boolean) => {setDialogOpen(boolean)}}
                managementState={managementState}  
                activeClearButton={activeButton}          
            />
            <ExceptionsFilterTable
                isMobile={isMobile}
                getExceptionFilter={props.getExceptionFilter}
                setExceptionFilter={props.setExceptionFilter}
            />
            <DatabaseTable
                isMobile={isMobile}
                dbClusterStatus={dbClusterStatus}
            />
            <DownloadSettingsTable
                isMobile={isMobile}
            />
            <ConfirmationDialog
                open={dialogOpen}
                setOpen={setDialogOpen}
                title="Clear database"
                cancelText="Cancel"
                confirmText="Yes, clear database"
                confirm={clearDb}
                confirmColor="error"
                text="This action will clear all data except for settings"
            />
        </>
    );
}

export default Management